import {Injectable} from "@angular/core";
import {fetchAuthSession, signInWithRedirect} from "@aws-amplify/auth";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  get token(): string | undefined  {
    return this._token;
  }

  private _token: string | undefined;
  constructor() {
  }

  public async authorize(): Promise<boolean> {
    const session = await fetchAuthSession();

    if (session.tokens) {
      this._token = session.tokens.accessToken.toString();
      return true;
    } else {
      await signInWithRedirect({});
      return false;
    }
  }
}
